const competitorAnalysisRoutes = [
  {
    path: '/competitor-analysis',
    redirect: '/competitor-analysis/list',
    children: [
      {
        path: '/list',
        name: 'CompetitorAnalysisList',
        component: () => import('@/views/competitor-analysis/list'),
        meta: {
          layout: 'DefaultLayout',
          title: '竞争对手分析',
          inNavbar: true,
          cache: true,
          pageType: 'public'
        }
      },
      {
        path: '/:companyId/detail',
        name: 'CompetitorAnalysisDetail',
        component: () => import('@/views/competitor-analysis/detail'),
        meta: {
          layout: 'DefaultLayout',
          title: '竞争对手分析报告',
          inNavbar: false,
          pageType: 'public'
        }
      }
    ]
  }
]

export default competitorAnalysisRoutes
